<template>
  <div class="nav-container w-full mt-3 sm:w-48 sm:h-full sm:mt-0">
    <div>
      <menu-component></menu-component>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MenuComponent from './MenuComponent.vue';

export default defineComponent({
  name: 'SideNavComponent',
  components: {
    MenuComponent,
  },
});
</script>

<style lang="scss" scoped>
.nav-container {
  background: #fff;
}
</style>
